import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableDatBim = Loadable({
  loader: () => import('./DatBim'),
  loading: Loader
});
